import { createReducer, on } from "@ngrx/store";
import { C_GameTypes, configDataModel } from "@sports-models/index";
import * as SportsbookActions from "../sportsbook.actions";

export const initialState: configDataModel = {
  betsData: null,
  gameTypes: null,
};

export const SportsbookConfigReducer = createReducer(
  initialState,
  on(SportsbookActions.setGameTypes, (state, gameTypes: C_GameTypes) => {
    return {
      ...state,
      gameTypes,
    };
  }),

  on(SportsbookActions.setBetsData, (state, { betsData }) => {
    return {
      ...state,
      betsData,
    };
  }),
);
